import { cn } from "@/lib/cn";
import type { LabOrder } from "@/types/labs";
import { labJourneyStep, labOrderLabel } from "./labPresentation";

const steps = [
  "Ordered",
  "Kit delivery",
  "Collect + return",
  "At the lab",
  "Results",
];

export function LabKitProgress({
  order,
  inverse = false,
}: {
  order: LabOrder;
  inverse?: boolean;
}) {
  const current = labJourneyStep(order);
  return (
    <ol
      aria-label={`Kit progress: ${labOrderLabel(order)}`}
      className="grid grid-cols-1 xs:grid-cols-5 gap-8 xs:gap-10"
    >
      {steps.map((label, index) => (
        <li
          key={label}
          aria-current={index === current ? "step" : undefined}
          className={cn(
            "flex xs:flex-col items-center xs:items-start gap-8 xs:gap-10 py-6 xs:pt-10 border-l-2 xs:border-l-0 xs:border-t-2 pl-10 xs:pl-0 min-w-0",
            inverse
              ? "border-white/25 text-white/60"
              : "border-line-subtle text-ink-muted",
            current !== null &&
              index <= current &&
              (inverse ? "border-white text-white" : "border-accent text-ink"),
          )}
        >
          <span className="font-mono text-12 shrink-0">0{index + 1}</span>
          <span className="font-body text-13 leading-130">{label}</span>
        </li>
      ))}
    </ol>
  );
}
